'use client'

import RenderInView from '@/app/(site)/components/render-in-view'
import LogoShapesAnimation from 'ui/src/components/logo-shapes-animation'
import { ANIMATION_SPEED } from '../../config/constants'
import { useWindowSize } from 'react-use'
import { ReactNode, useState } from 'react'

type Props = {
    children: ReactNode
}

const BackgroundAnimationLayout = ({ children }: Props) => {
    const { width } = useWindowSize()
    const [animationHeight, setAnimationHeight] = useState<number>(400)

    const handleContainerRef = (node: HTMLDivElement | null) => {
        if (!node) return
        setAnimationHeight(node.offsetHeight)
    }

    return (
        <div className="relative" ref={handleContainerRef}>
            <div className="absolute size-full inset-0">
                <RenderInView height={animationHeight}>
                    <LogoShapesAnimation width={width} height={animationHeight} speed={ANIMATION_SPEED} />
                </RenderInView>
            </div>

            <div className="relative">
                {children}
            </div>
        </div>
    )
}

export default BackgroundAnimationLayout
